import React from "react";
import { Input, InputProps } from "reactstrap";

import { useTranslation } from "react-i18next";
import { GenderEnum } from "../../enums";

type TProps = InputProps & {
  placeholder: string;
};

export const GenderSelect: React.FC<TProps> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="input-group">
      <Input {...props}>
        <option value={""}>{t(props.placeholder)} </option>
        <option
          value={GenderEnum.MALE}
          key={GenderEnum.MALE}
          className="text-capitalize"
        >
          {GenderEnum.MALE}
        </option>
        <option
          value={GenderEnum.FEMALE}
          key={GenderEnum.FEMALE}
          className="text-capitalize"
        >
          {GenderEnum.FEMALE}
        </option>
      </Input>
    </div>
  );
};
